import { render, staticRenderFns } from "./CreateAccount.admin.vue?vue&type=template&id=590a60b2&scoped=true&"
import script from "./CreateAccount.admin.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.admin.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount.admin.vue?vue&type=style&index=0&id=590a60b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a60b2",
  null
  
)

export default component.exports